import React from "react";

export function Info() {
  return (
    <>
      <div className="bg-remark p-4 rounded border border-label overflow-hidden">
        <h4 className="lg:text-lg font-bold mb-4">【活動詳情】</h4>
        <p className="mb-4">口罩牌子：OxyAIR Mask HK</p>
        <div className="flex flex-row">
          <p className="inline flex-grow-0">口罩規格：</p>
          <ol className="ml-4 list-decimal mb-8 flex-1">
            <li className="mb-4">
              <div className="inline-flex flex-row">
                <div>
                  OxyAIR 3 PLY Surgical Face Mask 彩虹口罩三色別注版
                  <br />
                  件數: 30（每盒3包，每包10件裝）
                  <br />
                  規格: PFE≧99%, BFE≧99%, VFE≧99%
                  <br />
                  尺寸: 17.5 x 9.5cm
                  <br />
                  顏色: 粉紫色x10，粉紅色x10，粉綠色x10
                  <br />
                  產地: 香港
                  <br />
                </div>
              </div>
            </li>
            <li className="mb-4">
              <div className="inline-flex flex-row">
                <div>
                  全天然消毒殺菌泡泡
                  <br />
                  件數: 1
                  <br />
                  容量: 50ml
                  <br />
                  顏色: 珍珠白 <br />
                  產地: 香港
                  <br />
                </div>
              </div>
            </li>
          </ol>
        </div>
        <h4 className="lg:text-lg font-bold mb-4">【活動時間】</h4>
        <ol className="list-decimal list-inside mb-8">
          <li className="mb-4">登記期間：6月4日晚上6:00 至 6月5日早上9:30</li>
          <li className="mb-4">登記名額：100,000（額滿即止）</li>
        </ol>

        <h4 className="lg:text-lg font-bold mb-4">【發貨時間】</h4>
        <ol className="list-decimal list-inside mb-8">
          <li className="mb-4">2020年7月16-31日期間按交易記錄次序發貨</li>
        </ol>

        <h4 className="lg:text-lg font-bold mb-4">【寄運選項】</h4>
        <p className=" mb-4">寄運費用，價格如下：</p>
        <ol className="ml-8 list-decimal list-inside mb-8">
          <li className="mb-4">Alfred 智能櫃 (劃一 $20運費)</li>
          <li className="mb-4">
            <p className="inline-block mb-4">順豐速運</p>

            <ol
              className="ml-8 list-disc list-inside mb-4"
              style={{ listStyleType: "lower-alpha" }}
            >
              <li className="mb-4">寄兩盒，郵費 $30</li>
              <li className="mb-4">寄三盒，郵費 $36</li>
            </ol>
          </li>
        </ol>

        <h4 className="lg:text-lg font-bold mb-4">【簡易購買5步曲】</h4>
        <ol className="list-decimal list-inside mb-8">
          <li className="mb-4">登入抽籤網</li>
          <li className="mb-4">
            輸入電郵及電話登記（電話及／或電郵均不能重複登記），選擇想購買的貨品項目，即時拿到籌號
          </li>
          <li className="mb-4">
            於2020年6月5日
            截止登記後進行抽籤，同日晚上會將結果通知中籤與不中籤人士
          </li>
          <li className="mb-4">成功中籤者會收到購買連結的電郵</li>
          <li className="mb-4">
            進入購買連結，就已選的貨品項目，進行結帳，完成購買
          </li>
        </ol>
        <h4 className="lg:text-lg font-bold mb-4">【登記方式】</h4>
        <ol className="list-decimal list-inside mb-8">
          <li className="mb-4">登記者在限時內輸入個人資料</li>
          <li className="mb-4">每個電郵及／或電話只能登記一次，重複無效</li>
          <li className="mb-4">
            <p className="mb-4 inline-block">
              每個登記限購一個選項，選項包括：
            </p>
            <ol
              className="ml-8 list-decimal list-inside mb-4"
              style={{ listStyleType: "lower-alpha" }}
            >
              <li className="mb-4">
                彩色口罩三色別注版「2 盒」，Alfred 智能櫃取貨 （共價 $200）
              </li>
              <li className="mb-4">
                彩色口罩三色別注版「3 盒」，Alfred 智能櫃取貨（共價 $290）
              </li>
              <li className="mb-4">
                彩色口罩三色別注版「2 盒」＋ 全天然消毒殺菌泡泡「1 瓶」，Alfred
                智能櫃取貨 （共價 $250）
              </li>
              <li className="mb-4">
                彩色口罩三色別注版「3 盒」＋ 全天然消毒殺菌泡泡「2 瓶」，Alfred
                智能櫃取貨 （共價 $390）
              </li>

              <li className="mb-4">
                彩色口罩三色別注版「2 盒」，使用順豐寄運 （共價 $210）
              </li>
              <li className="mb-4">
                彩色口罩三色別注版「3 盒」，使用順豐寄運（共價 $306）
              </li>
              <li className="mb-4">
                彩色口罩三色別注版「2 盒」＋ 全天然消毒殺菌泡泡「1
                瓶」，使用順豐寄運 （共價 $260）
              </li>
              <li className="mb-4">
                彩色口罩三色別注版「3 盒」＋ 全天然消毒殺菌泡泡「2
                瓶」，使用順豐寄運 （共價 $406）
              </li>
            </ol>
          </li>
          <li className="mb-4">
            <p className="mb-4 inline-block">寄運費用，價格如下：</p>
            <ol
              className="ml-8 list-decimal list-inside mb-4"
              style={{ listStyleType: "lower-alpha" }}
            >
              <li className="mb-4">Alfred 智能櫃 (劃一 $20運費)</li>
              <li className="mb-4">
                <p className="inline-block mb-4">順豐速運</p>

                <ol className="ml-8 list-disc list-inside mb-4">
                  <li className="mb-4">寄兩盒，郵費 $30</li>
                  <li className="mb-4">寄三盒，郵費 $36</li>
                </ol>
              </li>
            </ol>
          </li>
          <li className="mb-4">系統會在2020年6月5日進行抽籤</li>
          <li className="mb-4">
            中籤者（名額20,000）於2020年 6月5日晚上收到附有付款連結的電郵
          </li>
          <li className="mb-4">
            未能中籤者也會於2020年 6月6日 或以前收到未能成功的通知
          </li>
          <li className="mb-4">
            中籤者必須於2020年 6月8日中午 12:00 或以前完成付款，逾期付款連結無效
          </li>
          <li className="mb-4">確認付款後，客戶將收到確認通知</li>
          <li className="mb-4">
            2020年7月16-31日期間發貨，發貨後，客戶將收到發貨通知
          </li>
          <li className="mb-4">
            所有填寫的資料必須正確，如有任何錯誤、遺漏或無法辨識等情況下將有機會自動作廢
          </li>
          <li className="mb-4">登記一經確認，將不能更改任何登記資料</li>
          <li className="mb-4">閣下所提供的資料將會用作是次登記之用</li>
          <li className="mb-4">
            如有任何爭議，OxyAIR Mask HK 將保留最終決定權
          </li>
        </ol>

        <h4 className="lg:text-lg font-bold mb-4">【購買方式】</h4>
        <ol className="list-decimal list-inside mb-8">
          <li className="mb-4">
            每個成功登記，我們將會以電郵發放專屬你的購買連結。該購買連結只能使用一次
          </li>
          <li className="mb-4">
            付款方法包括：Visa, Mastercard, Apple Pay, Google Pay
          </li>
          <li className="mb-4">
            為了確保你的電郵系統不會把我們系統發出的電郵誤當為垃圾郵件，你可加我們系統電郵地址
            no-reply@noq.com.hk 為聯絡人，或檢查不會有電郵過濾把由
            no-reply@noq.com.hk 寄出的電郵歸類為垃圾郵件
          </li>
          <li className="mb-4">如有任何爭議，OxyAIR Mask HK將保留最終決定權</li>
        </ol>

        <h4 className="lg:text-xl font-bold mb-4">【條款】</h4>
        <ol className="list-decimal list-inside mb-8">
          <li className="mb-4">每人只限以一個電郵及電話預購一次；</li>
          <li className="mb-4">
            在產品預購結束後, 我們將無法接受取消或修改訂單,
            也無法因個人原因而提出要求產品交換/退款/退貨；
          </li>
          <li className="mb-4">
            成功中籤者，須提供收貨人姓名／聯絡電話／收貨地址，以安排物流公司送貨處理；
          </li>
          <li className="mb-4">
            <p className="inline-block mb-4">只限郵寄，不設自取。郵費如下：</p>
            <ol
              className="ml-8 list-decimal list-inside mb-4"
              style={{ listStyleType: "lower-alpha" }}
            >
              <li className="mb-4">Alfred 智能櫃 (劃一 $20運費)</li>
              <li className="mb-4">
                <p className="inline-block mb-4">順豐速運</p>

                <ol className="ml-8 list-disc list-inside mb-4">
                  <li className="mb-4">寄兩盒，郵費 $30</li>
                  <li className="mb-4">寄三盒，郵費 $36</li>
                </ol>
              </li>
            </ol>
          </li>
          <li className="mb-4">
            本公司不會為登記者 (如獲選)
            將貨品轉贈他人，也不可兌現金，不設退貨、退款；
          </li>
          <li className="mb-4">
            發貨日期時間定於2020年7月16-31日，會按完成交易記錄進行發貨；
          </li>
          <li className="mb-4">
            如產品未能在2020年7月31日或以前生產出來，你可以選擇退款或繼續等候。如選擇前者，我們將會把已收取的預訂金額如數於2020年8月15日或以前全數退回付款帳戶；
          </li>
          <li className="mb-4">
            本公司保留一切權利，可於任何時間及不時修改內容（包括我們所提供的服務）或更改本條款及細則，而無需作出通知；
          </li>
        </ol>
      </div>
    </>
  );
}
